import React, { FunctionComponent } from "react";
import PrintOptionAttributeComments from "./PrintOptionAttributeComments";
import PrintOptionImageGalleryHeightAndWidth from "./PrintOptionImageGalleryHeightAndWidth";
import PrintOptionPageHeader from "./PrintOptionPageHeader";
import PrintOptionPaperSizeAndOrientation from "./PrintOptionPaperSizeAndOrientation";

const PropertyPrintOptions: FunctionComponent = function PropertyPrintOptions() {
	return (
		<>
			<PrintOptionPaperSizeAndOrientation />
			<PrintOptionPageHeader />
			<PrintOptionAttributeComments />
			<PrintOptionImageGalleryHeightAndWidth />
		</>
	);
};

export default PropertyPrintOptions;